function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_15866_22588)",
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16 0a1 1 0 011 1v3.913a1 1 0 11-2 0V1a1 1 0 011-1zM12.74 27.391a1 1 0 100 2h6.521a1 1 0 000-2h-6.522zM14.043 30a1 1 0 100 2h3.913a1 1 0 100-2h-3.912zM5.638 4.877a1 1 0 00-1.414 1.415l2.768 2.767a1 1 0 001.414-1.415L5.638 4.877zM27.775 4.878a1 1 0 010 1.414l-2.767 2.766a1 1 0 11-1.414-1.414l2.766-2.766a1 1 0 011.415 0zM1 15.652a1 1 0 000 2h3.913a1 1 0 100-2H1zM26.087 16.652a1 1 0 011-1H31a1 1 0 010 2h-3.913a1 1 0 01-1-1z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.286 7.822a8.826 8.826 0 00-5.33 16.065.306.306 0 01.13.25v.994a1.652 1.652 0 001.653 1.652h6.522a1.652 1.652 0 001.652-1.652v-.996a.305.305 0 01.13-.25 8.795 8.795 0 003.783-7.232 8.826 8.826 0 00-8.54-8.83zm-3.442 2.77a6.826 6.826 0 019.982 6.06 6.801 6.801 0 01-2.924 5.591 2.305 2.305 0 00-.989 1.893v.647h-5.826v-.646a2.305 2.305 0 00-.988-1.892 6.826 6.826 0 01.745-11.654z"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_15866_22588"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h32v32H0z"
})))));